/**
 * Official group-stage letters for the expanded World Cup format.
 * Kept in a dependency-free module so helpers can import it without circular imports.
 */
export const WORLD_CUP_GROUP_STAGE_LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
] as const;
